import { DeliveryRules } from "modules/deliveryRules";

const DeliveryRulesPage = () => <DeliveryRules />;

export default DeliveryRulesPage;
